import { required, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { Dropdown } from '../../../../components/Dropdown'
import { TitleWithDashedLine } from '../../../../components/TitleWithDashedLine'
import { styles } from '../../styles'
import { LimitsTable } from './LimitsTable'

export const riskSettingsForm = (
  tipValue: string,
  deliveryPeriodValue: string,
  internationAcceptanceValue: string,
  refundValue: string,
  aditionalRefPercValue: string,
  openLoopRefundExitLimitValue: string,
  closeLoopRefundExitLimitValue: string,
  isSearchFlow: boolean,
  isEdit: boolean,
  entityId: string,
) => [
  {
    actionTitle: 'Proceed',
    key: 'riskSettings',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'tip',
            ComponentName: isEdit ? Dropdown : TextInputNew,
            title: 'Tip',
            validationSchema: isEdit ? required : undefined,
            label: 'Tip',
            value: isEdit ? undefined : tipValue,
            data: isEdit
              ? [
                  { id: 1, value: 'Yes' },
                  { id: 2, value: 'No' },
                ]
              : undefined,
            ...styles.textinputStyle(isEdit),
            testID: 'tip',
          },
          {
            fieldName: 'deliveryPeriod',
            ComponentName: isEdit ? Dropdown : TextInputNew,
            title: 'Delivery Period',
            validationSchema: isEdit ? required : undefined,
            label: 'Delivery Period',
            value: isEdit ? undefined : deliveryPeriodValue,
            data: isEdit
              ? [
                  { id: 1, value: 'Deferred Delivery' },
                  { id: 2, value: 'On Time Delivery' },
                ]
              : undefined,
            ...styles.textinputStyle(isEdit),
            testID: 'deliveryPeriod',
          },
          {
            fieldName: 'internationalAcceptance',
            ComponentName: isEdit ? Dropdown : TextInputNew,
            title: 'International Acceptance',
            validationSchema: isEdit ? required : undefined,
            label: 'International Acceptance',
            value: isEdit ? undefined : internationAcceptanceValue,
            data: isEdit
              ? [
                  { id: 1, value: 'Yes' },
                  { id: 2, value: 'No' },
                ]
              : undefined,
            ...styles.textinputStyle(isEdit),
            testID: 'internationalAcceptance',
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'refundsText',
            ComponentName: TitleWithDashedLine,
            title: 'Refunds',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'refund',
            ComponentName: isEdit ? Dropdown : TextInputNew,
            title: 'Refund',
            validationSchema: isEdit ? required : undefined,
            label: 'Refund',
            value: isEdit ? undefined : refundValue,
            data: isEdit
              ? [
                  { id: 1, value: 'Additional' },
                  { id: 2, value: 'Exact' },
                ]
              : undefined,
            ...styles.textinputStyle(isEdit),
            testID: 'refund',
          },
          {
            fieldName: 'additionalRefundPercentage',
            ComponentName: TextInputNew,
            label: 'Additional Refund Percentage',
            placeholder: '',
            value: isEdit ? undefined : aditionalRefPercValue,
            validationSchema: isEdit ? required : undefined,
            ...styles.textinputStyle(isEdit),
            testID: 'additionalRefundPercentage',
          },
          {
            fieldName: 'openLoopRefundExitLimit',
            ComponentName: TextInputNew,
            label: 'Open loop refund exit limit',
            placeholder: '',
            value: isEdit ? undefined : openLoopRefundExitLimitValue,
            validationSchema: isEdit ? required : undefined,
            ...styles.textinputStyle(isEdit),
            testID: 'openLoopRefundExitLimit',
          },
          {
            fieldName: 'closeLoopRefundExitLimit',
            ComponentName: TextInputNew,
            label: 'Close loop refund exit limit',
            placeholder: '',
            value: isEdit ? undefined : closeLoopRefundExitLimitValue,
            validationSchema: isEdit ? required : undefined,
            ...styles.textinputStyle(isEdit),
            testID: 'closeLoopRefundExitLimit',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'limitsText',
            ComponentName: TitleWithDashedLine,
            title: 'Limits',
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'limitsTable',
            ComponentName: LimitsTable,
            isSearchFlow: isSearchFlow,
            isEdit: isEdit,
            entityId: entityId,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
